<template>
	<BaseCenteredMessage data-test="cannot-load-session-container">
		<template #icon><BaseIcon name="mono/warn" class="w-40 h-40 text-yellow-500" /></template>
		<template #title>Cannot open recording</template>
		<template #details>
			Your account <span class="text-strong-base">{{ $auth.user.value.profile.email }}</span> may not have
			permission to view this recording, or it may have been deleted.
		</template>
		<template #actions="{loginWithDifferentAccount}">
			<router-link v-if="!$store.isExtension" to="/" class="inline-block button-green">
				Back to my account
			</router-link>
			<a v-else :href="$env.VUE_APP_URL" class="inline-block button-green">Back to my account</a>
			<button class="flex link-white text-strong-base mt-20 mx-auto" @click="loginWithDifferentAccount">
				Log in with different account
			</button>
		</template>
	</BaseCenteredMessage>
</template>
